<div class="controls-container">
  @if (hasTrigger && CALENDAR_OPTIONS[valueType!]) {
    <rt-input
      rt-overlay-origin
      #absolutePickerOrigin="rtOverlayOrigin"
      [readOnly]="true"
      [placeholder]="CalendarOptionsPlaceholders[valueType!]! | translate"
      [hasDropdownIndicator]="true"
      [class.dropdownOpened]="absolutePickerOverlay.open"
      [value]="selectedAbsoluteDateLabel"
      (click)="openAbsolutePicker(absolutePickerOrigin)"
      variant="rounded"
      class="control"
    />
  }

  @if (!hasTrigger && CALENDAR_OPTIONS[valueType!]) {
    <div class="control kalendae-has-no-padding">
      <ng-template [ngTemplateOutlet]="datePickerTmpl" />
    </div>
  }

  @if (RELATIVE_CUSTOM_OPTIONS[valueType!]) {
    <rt-input
      [formControl]="relativeCustomValueControl"
      [placeholder]="'app.views.filters.relative_data_input_placeholder' | translate"
      type="number"
      class="control"
    />
    <rt-select2
      [formControl]="relativeCustomUnitControl"
      [items]="relativeCustomUnits"
      class="control"
    />
  }
</div>

<ng-template
  #absolutePickerOverlay="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [rtConnectedOverlayPosition]="dropdownPosition"
  (backdropClick)="absolutePickerOverlay.open = false"
>
  <rt-dropdown [style.width]="'100%'" layout-centered>
    @if (valueType === DateRangeValueType.Range) {
      <rt-dropdown-header>
        {{ 'app.views.filters.date_range' | translate }}
      </rt-dropdown-header>
    }
    <ng-template [ngTemplateOutlet]="datePickerTmpl" />
  </rt-dropdown>
</ng-template>

<ng-template #datePickerTmpl>
  <rt-date-picker
    [mode]="customDatePickerConfig.mode"
    [months]="customDatePickerConfig.months"
    [blackout]="blackout"
    [direction]="customRangeDirection"
    [value]="datePickerValue"
    (valueChange)="handleCustomDateRangeChange($event)"
    (click)="$event.stopPropagation()"
  />
</ng-template>
